<div class="container">
  <div class="modal" tabindex="-1" role="dialog" id="modErrPay" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body"><span class="text-danger text-center font-weight-bold">{{message}}</span></div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center mt-3">
    <h3 class="text-center fw-bold col-sm-8">Paiements scolarité par anticipation</h3>
  </div>

  @if (isBill) {
  <div id="bill-page" class="payment-page mt-3">
    <form [formGroup]="formBill">
      <p class="text-center fw-bold">Paiement par anticipation</p>
      
      <div class="row justify-content-center">
        <div class="col-sm-6 form-group form-floating mb-3">
          <input type="text" class="form-control mt-2" placeholder="Entrer le code l'élève"
            formControlName="idStudent" id="idStudent">
          <label for="idStudent">Entrer le code compta de l'élève</label>
        </div>
      </div>
      <div class="d-grid gap-2 col-sm-3 mx-auto mt-2">
        <button class="btn btn-success" (click)="findStudent()" [disabled]="!formBill.valid">Chercher</button>
      </div>
    </form>
  </div>
  }

  @if (isPayment) {
  <div id="payment-page" class="payment-page">
    <h6 class="text-center fw-bold"> Paiement anticipé</h6>
    <form [formGroup]="formPayment">
      <input type="hidden" formControlName="school">
      <input type="hidden" formControlName="idStudent">
      @if(student){
      <div class="row justify-content-center">
        <div class="col-sm-6">
         
          <div class="mb-3">
            <span class="form-label">Nom de l'élève: <span class="fw-bold">{{student.studentName}}</span></span>
          </div>
        
      @if(fees>0){
      <div class="mb-3">
        <p >Frais de service :<span class="fw-bold">{{fees}}
            {{student.currency?.currencyCode}}</span></p>
      </div>
      }
      @if(taxe>0){
      <div class="mb-3">
        <p class="text-center">Taxe :<span class="fw-bold">{{taxe}}
            {{student.currency?.currencyCode}}</span></p>
      </div>
      }
      </div>
      </div>
      <div class="mb-3">
       
        <div class="row justify-content-center" id="echeances" formArrayName="echeances">
          <div class="col-sm-6">
             <span  class="form-label text-center mb-2">Veuille selectionner les échéances concernées</span>
            <div class="row justify-content-center mt-2" >
          @for (mois of listMois; track mois;let i=$index) {
          <div class="col-sm-4">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="mois-{{i}}" [formControlName]="i">
              <label class="form-check-label" for="mois-{{i}}">{{mois}}</label>
            </div>
          </div>
          }
          </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        
        <div class="col-sm-6 form-floating mb-3">
          <input class="form-control" formControlName="amount" type="text" id="amount" inputmode="numeric" pattern="[0-9]*" (input)="getAmount()"
            min="{{mminAmount}}">
          <label for="amount" class="fw-bold">Entrer le montant:</label>
        </div>
      </div>

      @if(this.amount>0){
      <div class="payment-header">
        <p class="text-center">Veuillez choisir le moyen de paiement <br>Et Renseignez votre numéro de
          téléphone du payeur</p>
      </div>
      <div class="row justify-content-center gap-method">
        <!--div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2 ml-3 p-2"
          style="width: auto;" data-method="card" (click)="onSelectPaymentMethod('card')">
          <img class="img-fluid" src="images/visamaster.png" alt="carte" width="50">
          <p class="mt-2 mb-0 text-center">Carte</p>
        </div>
        <div class="col-3 ml-2 payment-method border rounded d-flex flex-column justify-content-center mb-2"
          style="width: 135px;" data-method="omsn" (click)="onSelectPaymentMethod('omsn')">
          <img class="mt-4 img-fluid justify-content-center" src="images/omsn.webp" alt="orange money" width="50">
          <p class="mt-1 ml-3">Orange money</p>
        </div>
        <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2"
          data-method="wvsn" style="width: auto;" (click)="onSelectPaymentMethod('wvsn')">
          <img class="mt-4 img-fluid justify-content-center" src="images/wave-logo.webp" alt="wave" width="50">
          <p class="mt-1  ml-3">Wave</p>
        </div-->
         @for(p of paymentMeans; track p){
                <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2"
                  [attr.data-method]="p.code" style="width: auto;" (click)="onSelectPaymentMethod(p)">
                  <img class="mt-4 img-fluid justify-content-center" src="{{p.logo}}" alt="{{p.label}}" width="50">
                  <p class="mt-1  ml-3">{{p.label}}</p>
                </div>
                }
      </div>
      }
      <div class="row justify-content-center">
        <div class="col-sm-5 form-group form-floating">
          @if (isWallet) {
          <input type="tel" placeholder="Numero t&#233;l&#233;phone du payeur" class="form-control" formControlName="phone">
          <label>Entrer votre numero de téléphone du payeur</label>
          }
        </div>
      </div>
      }
      @if (isValid()&& !processing) {
      <div class="d-grid gap-2 col-sm-3 mx-auto">
        <button class="btn btn-primary mt-3" (click)="processPayment()">
          Valider</button>
      </div>
      }
    </form>
  </div>
  }

  @if(qrCode.length) {
  <div class="row justify-content-center">
    <div class="d-flex justify-content-center">Scannez et payez </div>
    <div class="d-flex justify-content-center">
      @if(paymentNetwork?.code?.toLocaleLowerCase() == 'wvsn'){
      <div class="d-block">
        <img class="img-fluid" src="images/wave-logo.webp" alt="wave" width="120" height="50">
      </div>
      }
      @if(paymentNetwork?.code?.toLocaleLowerCase() == 'omsn'){
      <div class="d-block">
        <img class="img-fluid" src="images/omsn.webp" alt="orange money" width="120" height="50">
      </div>
      }
    </div>
    <div class="d-flex justify-content-center">
      <qrcode [qrdata]="qrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
    </div>
    @if(!isDesktop){
    <div class="d-grid gap-2 col-sm-3 mx-auto">
      <button class="btn btn-primary" (click)="openUrl(qrCode)">Ouvrir avec l'application</button>
    </div>
    }
  </div>
  }
</div>
